import _ from "lodash";
import React from "react";
import classes from "./PaginationLoader.scss";
import Loading from "UIComponents/Loading";
import classNames from "classnames";

const PaginationLoader = props => {
  const { customLoaderClass, loadingStyle = {} } = props;

  const containerClass = classNames({
    [classes.loadingContainer]: true,
    [customLoaderClass]: !_.isEmpty(customLoaderClass),
  });

  return (
    <div className={containerClass}>
      <Loading loadingStyle={loadingStyle} />
    </div>
  );
};

export default PaginationLoader;
